import { plainAxiosInstanceAuth } from '../../api/apiMeta'

export const registerUser = (_, payload) => {
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .post(`/users`, {
                user: {
                    email: payload.email,
                    password: payload.password,
                    password_confirmation: payload.password_confirmation,
                    name: payload.name,
                    last_name: payload.last_name,
                    phone: payload.phone,
                    rol: payload.rol
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const loginUser = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .post(`/users/sign_in`, { user: { email: payload.email, password: payload.password } })
            .then((response) => {
                commit("setUserInfo", response);
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const logoutUser = ({ commit, state }) => {
    const config = {
        headers: {
            authorization: state.auth_token,
        },
    };

    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .delete(`/users/sign_out`, config)
            .then(() => {
                commit("resetUserInfo");
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const loginUserWithToken = ({ commit }, payload) => {
    const config = {
        headers: {
            Authorization: payload.auth_token,
        },
    };
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .get(`/member-data`, config)
            .then((response) => {
                commit("setUserInfoFromToken", response);
                resolve(true);
            })
            .catch(() => {
                commit("resetUserInfo")
                reject(false);
            });
    });
}

export const notAuthenticated = ({ commit }) => {
    commit("resetUserInfo");
}